import React from 'react';
import { Box, Chip, Button, Stack } from '@mui/material';
import QrCodeIcon from '@mui/icons-material/QrCode';
import DoneIcon from '@mui/icons-material/Done';
import PersonIcon from '@mui/icons-material/Person';
import CreditCardIcon from '@mui/icons-material/CreditCard';

function MemberCardStatusSection({ memberCardStats, onManageCards, onShowQr }) {
  const stats = memberCardStats || {
    namesToAsk: 0,
    cardsToPrint: 0,
    cardsPrinting: 0,
    cardsToLink: 0,
  };
  return (
    <Box
      sx={{
        mt: 2,
        p: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        flexWrap: 'wrap',
      }}
    >
      {stats.namesToAsk > 0 && (
        <Chip
          color='error'
          sx={{ color: 'black' }}
          icon={<PersonIcon />}
          label={`${stats.namesToAsk} ${
            stats.namesToAsk > 1 ? 'Spielernamen fehlen' : 'Spielername fehlt'
          } `}
          size='small'
        />
      )}
      {stats.cardsToPrint > 0 && (
        <Chip
          color='warning'
          icon={<CreditCardIcon />}
          label={`${stats.cardsToPrint} ${
            stats.cardsToPrint > 1 ? 'Karten fehlen' : 'Karte fehlt'
          } `}
          size='small'
        />
      )}
      {stats.namesToAsk === 0 && stats.cardsToPrint === 0 && stats.cardsPrinting === 0 && stats.cardsToLink === 0 && (
        <Chip color='success' icon={<DoneIcon />} label='Alle Karten liegen vor' size='small' />
      )}
      {stats.cardsPrinting > 0 && (
        <Chip
          icon={<CreditCardIcon color='primary' />}
          label={`${
            stats.cardsPrinting > 1 ? `${stats.cardsPrinting} Karten werden` : 'eine Karte wird'
          }  gedruckt`}
          size='small'
          variant='outlined'
          sx={{ p: 1, color: 'primary.main' }}
        />
      )}
      {stats.cardsToLink > 0 && (
        <Chip
          color='warning'
          icon={<CreditCardIcon />}
          label={`${stats.cardsToLink} ${
            stats.cardsToLink > 1 ? 'Karten müssen verknüpft werden' : 'Karte muss verknüpft werden'
          }`}
          size='small'
        />
      )}
      <Box sx={{ flex: 1 }} />
      <Stack direction='row' spacing={1} sx={{ width: { xs: '100%', md: 'auto' } }}>
        <Button
          variant='outlined'
          size='small'
          onClick={onShowQr}
          startIcon={<QrCodeIcon />}
          sx={{ width: { xs: '100%', md: 'auto' } }}
        >
          QR-Code
        </Button>
        <Button
          variant='contained'
          size='small'
          onClick={onManageCards}
          sx={{ width: { xs: '100%', md: 'auto' } }}
        >
          Karten verwalten
        </Button>
      </Stack>
    </Box>
  );
}

export default MemberCardStatusSection;
